export interface OBJ {
    status: string, contactType: string, lastName: string, firstName: string, gsdb: string, company: string, jobTitle: string, email: string, phoneNumber: string, modified: string, created: string
}

export interface CONTACT_TABLE_INTERFACE {
    ContactID: number, LastName: string, FirstName: string, CarrierID: number, 
    GSDB: string, Company: string, JobTitle: string, Email: string, 
    PhoneNumber: string, ContactTypeID: number, ContactType: string, 
    ContactStatusID: number, Status: string, Notes: string, BuyerCode: string, 
    BuyerLocation: string, CreatedOn: string, ModifiedOn: string, Selected?:boolean
}

export const contact_column_order = [
    {name:"Status", displayName:'Status' , order : 1},
    {name:"ContactType", displayName:'Contact Type', order : 2},
    {name:"LastName", displayName:'Last Name' , order : 3},
    {name:"FirstName", displayName:'First Name', order: 4},
    {name:"GSDB", displayName:'GSDB' , order : 5},
    {name:"Company", displayName:'Company' , order : 6},
    {name:"JobTitle", displayName:'Job Title' , order : 7},
    {name:"Email", displayName:'Email' , order : 8},
    {name:"PhoneNumber", displayName:'Phone Number' , order : 9},
    {name:"BuyerCode", displayName:'Buyer Code' , order : 10},
    {name:"BuyerLocation", displayName:'Buyer Location' , order : 11},
    {name:"CreatedOn", displayName:'Created (Date/Time)' , order : 12},
    {name:"ModifiedOn", displayName:'Modified (Date/Time)' , order : 13}
]